<template>
  <div>
    <div>
      <h2>{{ i18n.t('/PurchaseOrder/Klant') }}</h2>
      <div class="customer-details">
        <div
          v-if="hasCustomerDetails"
          class="customer-individual-data-block"
          data-qa="customer-data"
        >
          <customer-details :customer="customer" />
          <edit-customer :customer="customer" @update-customer="updateCustomer" />
          <app-button
            data-qa="deselect-customer-button"
            button-class="action-quiet"
            class="deselect-button"
            @click="deselectCustomer"
          >
            <svg
              width="15"
              height="15"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.2"
              aria-hidden="true"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
            <span>Deselecteer</span>
          </app-button>
        </div>
        <search-customer
          v-if="!displayCompanyDetails || !hasCustomerDetails"
          @select-customer="setCustomer"
        />
      </div>
    </div>

    <div v-if="displayCompanyDetails">
      <h2>{{ i18n.t('/company/blocktitle') }}</h2>
      <div class="customer-details customer-individual-data-block">
        <company-details :company="company" />
        <app-button
          data-qa="deselect-company-button"
          button-class="action-quiet"
          @click="deselectCompany()"
        >
          <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.2"
            aria-hidden="true"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
          <span>{{ i18n.t('/Company/DeselectCompany') }}</span>
        </app-button>
      </div>
    </div>

    <search-lease-company />
  </div>
</template>
<script>
import CustomerDetails from '@/components/generic/presentational/molecules/customerDetails/CustomerDetails.vue'
import SearchCustomer from '@/components/purchaseOrder/presentational/organisms/newCustomerSearch/PurchaseOrderSearchCustomer.vue'
import SearchLeaseCompany from '@/components/purchaseOrder/presentational/organisms/newCustomerSearch/AddLeaseCompany.vue'
import EditCustomer from '@/components/generic/presentational/organisms/editCustomer/EditCustomer.vue'
import CountryHelper from '@/helpers/CountryHelper'
import CompanyDetails from '@/components/generic/presentational/molecules/companyDetails/CompanyDetails.vue'
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import { EventBus } from '@/plugins/event-bus'
import { mapGetters, mapState } from 'vuex'
import StoreConnector from '@/helpers/StoreConnector'

export default {
  components: {
    SearchCustomer,
    EditCustomer,
    CustomerDetails,
    CompanyDetails,
    AppButton,
    SearchLeaseCompany,
  },
  props: {
    customer: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      customerSearchType: '',
      countryList: CountryHelper.countryList(),
      isEditingCurrentCustomer: false,
    }
  },
  computed: {
    ...mapState('user', ['dealerId']),
    ...mapGetters({
      company: 'purchaseOrder/customerCompany',
    }),
    customerSource() {
      return this.customer?.CustomerSource || ''
    },
    hasCustomerDetails() {
      return !!(this.customer?.PoId || this.customer?.CustomerMagicNumber)
    },
    hasCompanyDetails() {
      return this.company?.CustomerCompanyName != null
    },
    displayCompanyDetails() {
      return this.hasCompanyDetails
    },
  },
  mounted() {
    this.customerSearchType = this.getCustomerSourceType(this.customerSource)
  },
  created() {
    EventBus.$on('purchaseOrder/customerUpdated', () => {
      this.toggleSearchType('M')
    })
  },
  unmounted() {
    EventBus.$off('purchaseOrder/customerUpdated', () => this.toggleSearchType('M'))
  },
  methods: {
    getCustomerSourceType(customerSource) {
      switch (customerSource.toUpperCase()) {
        case 'MANUAL':
          return 'M'
        case 'AUTOLINE':
          return 'A'
        case 'CMDM':
          return 'A'
        default:
          return ''
      }
    },
    toggleSearchType(value) {
      this.customerSearchType = value
      this.updateCustomerSource()
    },
    setCustomer(customer) {
      let isCompany = customer?.AutolineCustomerType == 'C'
      if (isCompany) {
        this.$store.dispatch('purchaseOrder/setCompany', customer)
      } else {
        this.$store.dispatch('purchaseOrder/setCustomer', customer)
      }
    },
    updateCustomer(customer) {
      this.setCustomer(customer)
      this.$store.dispatch('customer/updateAccount', {
        customer,
        dealerId: this.dealerId,
        quoteId: this.$route.params.quoteId,
      })
    },
    updateCustomerSource() {
      this.setCustomer({
        ...this.customer,
        CustomerSource: this.customerSearchType === 'M' ? 'MANUAL' : null,
      })
    },
    deselectCustomer() {
      StoreConnector.dispatch('purchaseOrder/resetCustomer', {})
    },
    deselectCompany() {
      this.$store.dispatch('purchaseOrder/resetCustomerCompany', {})
    },
  },
}
</script>
<style lang="scss" scoped>
h2 {
  font-size: 1.46191rem;
  margin-bottom: var(--space-xxs);
}

.customer-details {
  padding-top: 0.5em;
  padding-left: 1em;
}

.deselect-button {
  margin-left: 0.25em;
}
</style>
